import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTabsModule } from "@angular/material/tabs";

import { mdiClose } from "@mdi/js";
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from "ngx-mask";

import { DffButtonModule, DffInfoDialogModule, DffSimpelDialogModule, RevealOnFocusModule, SpinnerModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";

import { KontaktoplysningerPopupContentComponent } from "./kontaktoplysninger-popup-content/kontaktoplysninger-popup-content.component";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatStepperModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        SpinnerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        DffSimpelDialogModule,
        DffButtonModule,
        RevealOnFocusModule,
        DffInfoDialogModule
    ],
    declarations: [KontaktoplysningerPopupContentComponent],
    exports: [],
    providers: [provideEnvironmentNgxMask()]
})
export class KontaktoplysningerPopupModule {
    constructor(iconRegistry: SvgIconRegistry) {
        iconRegistry.registerIcon(mdiClose, "kontaktoplysninger-dialog-close-icon");
    }
}
